import { inject } from 'aurelia-framework';
import { NewInstance } from 'aurelia-dependency-injection';
import { ValidationController, validateTrigger, ValidationRules, ValidateBindingBehavior, ValidationRenderer } from 'aurelia-validation';
import { UserService } from '../Advertiser.SharedPortal/services/user-service';
import { LoggerService } from '../Advertiser.SharedPortal/services/logger-service';
import { StatusService } from '../Advertiser.SharedPortal/services/status-service';
import { MultiObserverService } from '../Advertiser.SharedPortal/services/multi-observer-service';
import { BrowserStorageService } from '../Advertiser.SharedPortal/services/browser-storage-service';


var config = require('../../config.js');


@inject(UserService, NewInstance.of(ValidationController), LoggerService, StatusService, MultiObserverService, BrowserStorageService)
export class ConfirmForgotPassword {
   constructor(userService, controller, loggerService, status, multiObserver, browserStorage) {
      this.userService = userService;
      this.controller = controller;
      this.controller.validateTrigger = validateTrigger.manual;
      this.logger = loggerService;
      this.status = status;
      this.multiObserver = multiObserver;
      this.browserStorage = browserStorage;

      this.errorMessage = '';
      this.submitted = false;
      this.emailAddress = '';
      this.deltyCode = '';
      this.newPassword = '';
      this.newPassword2 = '';

      this.myKeypressCallback = this.keypressInput.bind(this);
   }

   activate(params, routerConfig) {
      let that = this;
      this.deltyCode = params.deltycode;
      this.configStatus();
      this.multiObserver.observe(this, ['emailAddress', 'deltyCode', 'newPassword', 'newPassword2'], function () { that.status.dirty(); });
      window.addEventListener('keypress', this.myKeypressCallback, false);
   }

   deactivate() {
      window.removeEventListener('keypress', this.myKeypressCallback);
   }

   keypressInput(e) {
      if (e.key === 'Enter') {
         this.onSubmit();
      }
   }

   configStatus() {
      // statuses:  dontchange, clean, dirty, working, loading, saving, success, error
      this.status.texts = ['', 'Confirm Password', 'Confirm Password', 'Confirming Password', '', '', 'Confirmed Password', 'Error'];
      this.status.classes = ['', 'btn-disabled', 'btn-enabled', 'btn-processing', '', '', 'btn-success', 'btn-error'];
      this.status.clean();
   }

   onSubmit() {
      this.logger.debug('onSubmit() called');
      let that = this;

      let errors = this.controller.validate()
         .then((err) => {

            if (err.valid) {
               this.status.working();
               this.errorMessage = '';
               this.controller.reset();
               let token = this.browserStorage.getItem('AccessToken');

               this.userService.confirmForgotPassword(this.emailAddress, this.deltyCode, this.newPassword)
                  .then(response => {
                     if (response && response[0] !== 'Success') {
                        this.errorMessage = response;
                        this.submitted = false;
                        that.status.set(that.status.statuses.error, that.status.statuses.clean, config.buttonReset);
                     }
                     else {
                        this.errorMessage = '';
                        this.submitted = true;
                        that.status.set(that.status.statuses.success, that.status.statuses.clean, config.buttonReset);
                        //call confirmation email here
                        this.userService.emailPasswordChangeConfirmation(this.emailAddress).then(response => {
                           if(response && response[0] !== 'Success'){
                              //Error message that the email did not get sent. Password still changed though
                              this.errorMessage = response;
                              this.submitted = true;
                              that.status.set(that.status.statuses.error, that.statuses.clean, config.buttonReset);
                           }else {
                              this.errorMessage = '';
                              this.submitted = true;
                              that.status.set(that.status.statuses.success, that.status.statuses.clean, config.buttonReset);
                           }
                        });
                     }
                  });
            }
         });
   }
}

var passwordRegex = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\^\$\*\.\[\]\{\}\(\)\?\-\"\!\@\#\%\&\/\,><':;|_~`]).{8,}/;
var passwordFormatMessage = 'Sorry, your password is formatted incorrectly. Passwords must be at least 8 characters including one number, one upper, one lowercase letter, and a special character: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / , > < \' : ; | _ ~ `';
var passwordMatchMessage = 'Sorry, your passwords don\'t match. Please re-enter your passwords.';

ValidationRules
   .ensure(p => p.emailAddress).required()
   .ensure(p => p.emailAddress).email().withMessage('Email address is improperly formated (please ensure it is all lowercase)')
   .ensure(p => p.deltyCode).required().matches(/\d{5,9}/)
   .ensure(p => p.newPassword).required()
   .ensure(p => p.newPassword).matches(passwordRegex).withMessage(passwordFormatMessage)
   .ensure(p => p.newPassword2).required().withMessage('Re-entered password is required')
   .ensure(p => p.newPassword2).satisfies((value, obj) => value === obj.newPassword).withMessage(passwordMatchMessage)
   .on(ConfirmForgotPassword);
   